import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';


import styles from './index.module.scss';
import gtm from 'eco-design-reliance/gtm';
import { useCallback } from 'react';

const G_TAB_CHANGE_EVENT = 'delta3-g-tab-change';

/** 三列：左 1+4，中 2+6，右 3+5+7，与设计稿宽高比例一致 */
const COL_INDICES: number[][] = [
    [0, 3],
    [1, 5],
    [2, 4, 6],
];

export default function TheComp() {
    const { t } = useLang('delta3series');


    const arr = [
        { href: "#SecurityProtection", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283604355/1-pc-1.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283603303/1-m-1.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283603303/1-m-1.jpg' },
        { href: "#D3-MX1", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283604172/1-pc-2.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283605866/1-m-2.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283605866/1-m-2.jpg' },
        { href: "#D3-G", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283605483/1-pc-3.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283603606/1-m-3.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283603606/1-m-3.jpg' },
        { href: "#D3-E", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283605101/1-pc-5.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283603764/1-m-5.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283603764/1-m-5.jpg' },
        { href: "#D3-G", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283605299/1-pc-4.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283603982/1-m-4.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283603982/1-m-4.jpg' },
        { href: "#D3-C", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283604938/1-pc-6.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283604745/1-m-6.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283604745/1-m-6.jpg' },
        { href: "#D3-NA4-2", pc: 'https://websiteoss.ecoflow.com/upload/image/1775283605666/1-pc-7.jpg', pad: 'https://websiteoss.ecoflow.com/upload/image/1775283604546/1-m-7.jpg', h5: 'https://websiteoss.ecoflow.com/upload/image/1775283604546/1-m-7.jpg' },
    ];
    const handleScrollInToView = useCallback((href: string, idx: string) => {
        if (!href) return;

        const elementId = href.replace('#', '');
        const element = document.getElementById(elementId);

        if (element) {
            if (idx === 'item3' || idx === 'item5') {
                const tabType = idx === 'item3' ? 'a1' : 'a2';
                window.dispatchEvent(new CustomEvent(G_TAB_CHANGE_EVENT, {
                    detail: { tabType },
                }));
            }

            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            gtm.push({
                __btn_id1: `${styles.TheComp} .${idx}`,
                __btn_id2: href,
                __btn_type: 'common',
            });
        } else {
            console.warn(`Element with id "${elementId}" not found`);
        }
    }, []);

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range1`} data-section-id="D3-B" id='D3-B'>
            <EfSpec className="spec-x" />
            <div className={`${styles.items}`}>
                {COL_INDICES.map((indices, colKey) => (
                    <div className={styles.col} key={colKey} >
                        {indices.map((k) => {
                            const item = arr[k];
                            return (
                                <div className={`item item${k + 1} GtmModuleData-btn-common`} key={k} onClick={() => {
                                    handleScrollInToView(item.href, `item${k + 1}`);
                                }}>
                                    <div className="item-img">
                                        <EfImg pc={item.pc} pad={item.pad} h5={item.h5 ?? item.pc} />
                                        <div className="item-info">
                                            <p className="item-name">
                                                {t.rich(`B_text${k + 1}_name`, {
                                                    b: (tx: string) => <span className="blue">{tx}</span>,
                                                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                                                })}
                                            </p>
                                            <p className="item-desc">
                                                {t.rich(`B_text${k + 1}_desc`, {
                                                    b: (tx: string) => <span className="blue">{tx}</span>,
                                                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
            <EfSpec className="spec-x" />
        </div>
    );
}
